export default "__VITE_ASSET__fZUBhrYf__"